import loadable from "@loadable/component";
import { connect } from "react-redux";
import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";
import removeTaskProp from "../../../../../store/plan/actions/removeTaskProp";

import loadableComponent from "./loadable";

export default connect(null, { post, editTask, removeTaskProp })(loadableComponent);
